var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAvailable)?_c('ejs-button',{attrs:{"cssClass":"e-link"},nativeOn:{"click":function($event){return _vm.clientBtnClick(_vm.clientId)}}},[_vm._v(_vm._s(_vm.clientName))]):_c('span',[_vm._v(_vm._s(_vm.clientName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }